// extracted by mini-css-extract-plugin
export var active = "pagination-module--active--5LkfV";
export var container = "pagination-module--container--RX3m2";
export var dots = "pagination-module--dots--oRy3H";
export var grid = "pagination-module--grid--H5Ut9";
export var linksBox = "pagination-module--links-box--yZVuw";
export var next = "pagination-module--next--dGPa1";
export var pageLink = "pagination-module--page-link--CXbWR";
export var prev = "pagination-module--prev--zvVRh";
export var visible = "pagination-module--visible--+1I4I";